import React from 'react';
import { ScrollContainerStyled } from './styles';

const ScrollBar = ({ children }) => {
  return <ScrollContainerStyled>{children}</ScrollContainerStyled>;
};

export default ScrollBar;
